import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { useParams } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { BackdropCircular, Breadcrumb } from 'components';
import {
  getDraftQuotesByCustomerApi,
  getQuoteCustomerDataApi,
  getQuoteProProductsApi,
  getStoreProductsApi
} from 'api';
import { setSelectedDraftedQuote } from 'redux/actions/quote';
import QuoteSummaryPatient from 'pages/quotes/QuoteSummary/QuoteSummaryPatient';
import PatientActivity from './PatientActivity';
import PatientActivitySummaryCard from './PatientActivitySummaryCard';


const PatientDetails = () => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState('draft_patient_history');

  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const {id} = useParams<{ [id: string]: string }>();

  const {
    loadingDraftedQuotes,
    loadingCustomerAmastyQuotes,
    quoteProducts,
    allQuoteProducts,
    currentQuoteCustomer,
    loadingQuoteCustomers,
    loadingCheckout,
    quoteProductsLoading,
  } = useSelector((state: IReduxState) => state.quote);

  const loading =
    loadingDraftedQuotes ||
    loadingQuoteCustomers ||
    loadingCheckout ||
    loadingCustomerAmastyQuotes ||
    quoteProductsLoading;

  useEffect(() => {
    if (!currentQuoteCustomer) {
      getQuoteCustomerDataApi({ dispatch, id });
    }
  }, [currentQuoteCustomer, dispatch, id]);

  useEffect(() => {
    getDraftQuotesByCustomerApi({ dispatch, customerId: id });
  }, []);

  useEffect(() => {
    if (!allQuoteProducts.length && !quoteProducts.length) {
      getQuoteProProductsApi({dispatch});
      getStoreProductsApi({dispatch});
    }
  }, [quoteProducts, dispatch, id]);

  useEffect(() => {
    return () => {
      dispatch(setSelectedDraftedQuote({}));
    };
  }, [dispatch]);

  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote', path: '/quoting' },
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Details`, path: `/quoting/profile/${id}` },
            { name: 'Quote Workspace', path: `/quoting/profile/${id}/quote-workspace` },
            { name: `${isCustomer3 ? 'Customer' : 'Patient'} Activity` }
          ]}
        />
      </div>
      <Grid container spacing={3} className="px-8">
        <Grid item xs={12} md={8}>
          <PatientActivity
            setSelectedTab={setSelectedTab}
            selectedTab={selectedTab}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <QuoteSummaryPatient />
          <br />
          <PatientActivitySummaryCard selectedTab={selectedTab} />
        </Grid>
      </Grid>
      <BackdropCircular loading={loading} />
    </div>
  );
};

export default PatientDetails;
